import {
  Checkbox,
  Grid,
  Select,
  Text,
  TextInput,
  useMantineColorScheme,
} from "@mantine/core";
import { IconCaretDownFilled } from "@tabler/icons-react";
import { useCurrency } from "../../../../utils/helpers";
import PropTypes from "prop-types";
import { formatInputValue, responsiveCol } from "../../../../constants/helper";
import { useAtom } from "jotai";
import { projectDetailsAtom } from "../../../../utils/atoms/projectDetailsAtom";
import { useMemo } from "react";

const Co2EmissionFixed = (props) => {
  const { form, handleInputChange, gridParameters, getFieldAttributes } = props;
  const { colorScheme } = useMantineColorScheme();
  const currency = useCurrency();
  const [projectDetails] = useAtom(projectDetailsAtom);

  const co2Enabled = Boolean(
    gridParameters?.uiAttributes?.gridParameters?.co2Optimization
  );

 const grayIconStyle = useMemo(
   () => ({
     padding: "4px",
   }),
   [colorScheme],
  ); 

  // Determine if any relevant TextInput has validation errors
  const hasTextInputErrors = Boolean(
    form?.errors?.[
      "componentAttributes.gridParameters.co2Emission.gridEmissionFactor"
    ] || form?.errors?.["economicAttributes.gridParameters.price"]
  );

  return (
    <>
      <Text component="span" fw={700}>
        Configure CO<sub>2</sub> Emission Data for Carbon Footprint Analysis
      </Text>
      {/* <Grid gutter="md" className="mt-2 mb-2">
        <Grid.Col
          className={`d-flex ${
            hasTextInputErrors ? "align-items-center" : "align-items-end"
          }`}
          {...responsiveCol}
        >
          <Checkbox
            label={
              <>
                Enable CO<sub>2</sub> Optimization
              </>
            }
            name="co2_emission.co2_optimization"
            checked={
              gridParameters?.uiAttributes?.gridParameters?.co2Optimization
            }
            {...form.getInputProps(
              "uiAttributes.gridParameters.co2Optimization"
            )}
            onChange={(event) => {
              handleInputChange(
                "uiAttributes",
                "co2Optimization",
                event.currentTarget.checked
              );
            }}
          />
        </Grid.Col>
      </Grid> */}
      <Grid gutter="md" className="mt-2 mb-2">
        <Grid.Col {...responsiveCol}>
          <Select
            {...getFieldAttributes("field-1")}
            data-id="field-1"
            data-testid="co2-emission-type"
            rightSection={<IconCaretDownFilled size={18} />}
            rightSectionProps={{ style: { pointerEvents: "none" } }}
            label={
              <>
                Select CO<sub>2</sub> Emission Type
              </>
            }
            data={[
              { value: "Fixed", label: "Fixed" },
              { value: "Variable", label: "Variable", disabled: true },
            ]}
            withAsterisk={co2Enabled}
            required={co2Enabled}
            placeholder="Select an option"
            value={
              gridParameters?.componentAttributes?.gridParameters?.co2Emission
                ?.type
            }
            {...form.getInputProps(
              "componentAttributes.gridParameters.co2Emission.type"
            )}
            onChange={(value) => {
              handleInputChange(
                "componentAttributes",
                "co2Emission.type",
                value
              );
            }}
            withinPortal
          />
        </Grid.Col>
        {gridParameters?.componentAttributes?.gridParameters?.co2Emission
          ?.type === "Fixed" && (
          <Grid.Col {...responsiveCol}>
            <TextInput
              {...getFieldAttributes("field-3")}
              data-id="field-3"
              label="Constant Grid Emission Rate (Weight)"
              placeholder="Add constant grid emission rate"
              {...form.getInputProps(
                "componentAttributes.gridParameters.co2Emission.gridEmissionFactor"
              )}
              onChange={(event) => {
                const formattedValue = formatInputValue(event.target.value);
                handleInputChange(
                  "componentAttributes",
                  "co2Emission.gridEmissionFactor",
                  formattedValue
                );
              }}
              required={co2Enabled}
              data-testid="co2-grid-emission"
              rightSection={
                <div style={{ ...grayIconStyle, marginRight: "1.5rem" }}>
                  g/kWh
                </div>
              }
              rightSectionProps={{ style: { pointerEvents: "none" } }}
              rightSectionWidth={60}
            />
          </Grid.Col>
        )}
        {/* <Grid.Col {...responsiveCol}>
          <TextInput
            {...getFieldAttributes("field-4")}
            data-id="field-4"
            data-testid="co2-price"
            label={
              <>
                CO<sub>2</sub> {`Emission Cost Impact`}
              </>
            }
            id="price"
            type="number"
            name="co2_emission.price"
            placeholder="Price of Co2 Emission"
            maxLength="100"
            required={co2Enabled}
            {...form.getInputProps("economicAttributes.gridParameters.price")}
            onChange={(event) => {
              handleInputChange(
                "economicAttributes",
                "price",
                event.target.value
              );
            }}
            rightSection={
              <div style={{ ...grayIconStyle, marginRight: "1rem" }}>
                {currency || "$"}/Tonne
              </div>
            }
            rightSectionProps={{ style: { pointerEvents: "none" } }}
            rightSectionWidth={60}
          />
        </Grid.Col> */}
      </Grid>
    </>
  );
};

Co2EmissionFixed.propTypes = {
  form: PropTypes.object,
  handleInputChange: PropTypes.func,
  gridParameters: PropTypes.object,
  getFieldAttributes: PropTypes.func,
};

export default Co2EmissionFixed;
